import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class LoadingStatusService {
  private count = 0;
  loading = false;

  show() {
    this.count++;
    setTimeout(() => this.updateVisibility(), 100);
  }

  hide() {
    this.count--;
    this.updateVisibility();
  }

  private updateVisibility() {
    this.loading = this.count > 0;
  }
}
